import React, { useState } from 'react'
import { Fade } from 'react-reveal'
import { GatsbyImage } from 'gatsby-plugin-image'
import PropTypes from 'prop-types'

import QuoteGraphic from './primitives/QuoteGraphic'

import {
  Outer,
  Wrapper,
  Graphic,
  Text,
  Controller,
  Control,
} from './Testimonials.styles'

const Testimonials = ({ texts, logos }) => {
  const [clickIndex, setClickIndex] = useState(0)

  return (
    <Outer>
      <Wrapper>
        <Graphic>
          <QuoteGraphic />
          <QuoteGraphic />
        </Graphic>
        {texts.map((text, i) => {
          if (i === clickIndex) {
            return (
              <Fade duration={2000} delay={200} key={`text${i}`}>
                <Text>
                  <h1>{text.quote}</h1>
                  <h2>{text.name}</h2>
                  <div className="bottom">
                    <p>{text.title}</p>
                    <p>{text.company}</p>
                  </div>
                </Text>
              </Fade>
            )
          } else {
            return null
          }
        })}

        <Controller>
          {logos.map((logo, i) => (
            <Control
              key={`logo${i}`}
              onClick={() => setClickIndex(i)}
              className={clickIndex === i ? 'active' : ''}
            >
              <GatsbyImage image={logo} alt="Logo" />
            </Control>
          ))}
        </Controller>
      </Wrapper>
    </Outer>
  )
}

Testimonials.propTypes = {
  texts: PropTypes.arrayOf(PropTypes.object).isRequired,
  logos: PropTypes.array.isRequired,
}

export default Testimonials
